module.exports = __webpack_public_path__ + "static/media/carp.80081260.png";